import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=6830a714&scoped=true"
import script from "./Consulta.vue?vue&type=script&lang=js"
export * from "./Consulta.vue?vue&type=script&lang=js"
import style0 from "./Consulta.vue?vue&type=style&index=0&id=6830a714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830a714",
  null
  
)

export default component.exports